/* eslint-disable */
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import addGeometryAndNamedValuesState from "utils/addGeometryAndNamedValuesState";
import getFieldDomain from "utils/getDomain";
import { NotificationManager } from "react-notifications";
import { ErrorHandelFunctionApp } from "utils/ErrorHandelFunction";

/**
 * @param {Object[]} options function params
 * @param options.view esri view required
 * @param options.token esri token optional.
 * @param options.layerId you can get it from esri urls context required.
 * @param options.layer esri layer name.
 * @param options.query default is 1=1.
 * @param options.outFields default is *.
 * @param options.externalDomains in case you want provide your own domains injected in to result --- optional ---.
 * @param options.spatialReference esri spatialReference required if isCustomSpatialReference is true.
 * @param options.isCustomSpatialReference true or false.
 * @param options.returnDistinctValues queryFeatures option.
 */
export default async function getEsriData({
  view,
  token,
  layerId,
  neededDomains,
  query = "1=1",
  geometry,
  outFields,
  externalDomains,
  spatialReference,
  isCustomSpatialReference,
  returnDistinctValues,
  layer,
  featureOrMap = "FeatureServer",
  returnGeometry = true,
  objectIds,
  queryFeaturesOptions = {},
}) {
  const url = `${
    process.env.REACT_APP_SERVICE_ENDPOINT
  }/${layer}/${featureOrMap}/${layerId}?${token ? `&token=${token}` : ""}`;
  const domainUrl = `${
    process.env.REACT_APP_SERVICE_ENDPOINT
  }/${layer}/${featureOrMap}/${layerId}?f=pjson${
    token ? `&token=${token}` : ""
  }`;

  const serverFeatureLayer = new FeatureLayer({
    url,
  });
  // let domains;
  // let fields;
  const neededDomainsObject = {};
  neededDomains?.forEach((domain) => {
    neededDomainsObject[domain] = domain;
  });
  const { domains: resultDomains, fields: resultFields } = await getFieldDomain(
    neededDomains,
    true,
    domainUrl
  );
  const domains = externalDomains || resultDomains;
  const fields = resultFields;
  let serverFeatureLayerQuery = {};
  try {
    serverFeatureLayerQuery = await serverFeatureLayer.queryFeatures({
      where: query || `1=1`,
      objectIds: objectIds || null,
      outFields: outFields || "*",
      returnGeometry,
      geometry,
      outSpatialReference: isCustomSpatialReference
        ? spatialReference
        : view?.spatialReference,
      returnDistinctValues: returnDistinctValues || false,
      ...queryFeaturesOptions,
    });
  } catch (error) {
    ErrorHandelFunctionApp(error)
  }
  const res = addGeometryAndNamedValuesState(
    serverFeatureLayerQuery.features,
    domains
  );
  return {
    domains,
    fields,
    res,
    serverFeatureLayer,
    serverFeatureLayerQuery,
  };
}
